import type * as React from "react";
import { Box, Typography } from "@mui/material";
import type { SxProps, Theme } from "@mui/material/styles";
import { Link as RouterLink } from "react-router-dom";
import { COLORS } from "components/v3/Theme/colors";

type RouterLinkTo = React.ComponentProps<typeof RouterLink>["to"];

type AccountExitLinkBaseProps = {
  label?: React.ReactNode;
  sx?: SxProps<Theme>;
};

export type AccountExitLinkProps = AccountExitLinkBaseProps &
  (
    | {
        onClick?: undefined;
        to: RouterLinkTo;
      }
    | {
        onClick: () => void;
        to?: undefined;
      }
  );

const sharedSx = {
  background: "none",
  border: "none",
  color: COLORS.DARK_GRAY,
  cursor: "pointer",
  padding: 0,
  textAlign: "left" as const,
  textDecoration: "none",
  width: "fit-content",
  "&:hover": {
    color: COLORS.DARK_GRAY,
    "& .MuiTypography-root": {
      color: COLORS.DARK_GRAY
    }
  }
} as const;

const AccountExitLink: React.FC<AccountExitLinkProps> = ({
  label = "← Exit",
  onClick,
  sx,
  to
}) => (
  <Box
    component={onClick ? "button" : RouterLink}
    onClick={onClick}
    to={to}
    sx={{ ...sharedSx, ...sx }}
  >
    <Typography variant="body_strong_dark_gray" component="span">
      {label}
    </Typography>
  </Box>
);

export default AccountExitLink;
